<template>
	<v-layout justify-center align-center>
		<v-card width="70%" class="card-style pa-3">
			<v-card-title>
				<v-container fluid class="pa-0">
					<v-layout justify-center row>
						<h1 style="opacity: 0.8">Preencha o formulário</h1>
					</v-layout>
				</v-container>
			</v-card-title>
			<v-card-actions>
				<v-flex>
					<v-form ref="form" lazy-validation>
						<v-select
							v-model="campaign"
							:items="itemsCampaigns"
							:rules="rules"
							label="Campanha"
							required />

						<v-text-field
							v-model="name"
							:rules="rules"
							label="Nome"
							required />

						<v-text-field
							v-model="email"
							:rules="emailRules"
							label="E-mail"
							required />

						<v-text-field
							v-model="phone"
							label="Telefone"
							:rules="phoneRules"
							required
							v-mask="'(##) #####-####' || '(##) ####-####'"/>

						<v-combobox
							class="mb-4"
							v-model="items"
							:items="[]"
							placeholder="Identificador"
							color="green"
							multiple
							chips
							flat
							hide-details
							append-icon="">
							<template v-slot:selection="items">
								<v-chip close @input="deleteIdentifier(items.item)">
									<strong>{{ items.item }}</strong>
								</v-chip>
							</template>
						</v-combobox>

						<v-btn color="primary" @click="sendForm"> Gerar código </v-btn>
					</v-form>
				</v-flex>
			</v-card-actions>
		</v-card>
	</v-layout>
</template>

<script>

export default {
	name: 'Formulario',

	data: () => ({
		itemsCampaigns: ['Farmembro', 'Enfermeiros ou parceiros', 'Clientes time de sucesso', 'Publico', 'Farmezeiros', 'Black Friday'],
		campaign: '',
		name: '',
		rules: [v => !!v || '*Obrigatório'],
		email: '',
		emailRules: [v => !!v || '*Obrigatório', v => /.+@.+/.test(v) || 'E-mail inválido'],
		phone: '',
		phoneRules: [v => !!v || '*Obrigatório', v => /^\([1-9]{2}\) (?:[2-8]|9[0-9])[0-9]{3}-[0-9]{4}$/.test(v) || 'Telefone inválido'],
		items: [],
		form: {}
	}),
	methods: {
		sendForm() {
			if (!this.$refs.form.validate()) {
				this.$store.dispatch('SHOW_SNACKBAR', { message: 'Preencha os campos obrigatórios', color: 'error' });
				return;
			}

			this.form = {
				name: this.name,
				email: this.email,
				phone: this.$functions.onlyNumber(this.phone),
				groups: this.items,
				sponsor: {
					name: 'Far.me',
					email: 'indicame@farme.com.br'
				}
			};

			let campaign = '';

			switch (this.campaign) {
				case 'Farmembro (CLIENTE OU RESPONSÁVEL)':
					campaign = 'cashback-farme';
					break;
				case 'Enfermeiros ou parceiros':
					campaign = 'profissionais-saude';
					break;
				case 'Clientes time de sucesso':
					campaign = 'growth-sucesso';
					break;
				case 'Publico':
					campaign = 'public-farme';
					break;
				case 'Black Friday':
					campaign = 'black-friday-2023';
					break;
				case 'Farmezeiros (FUNCIONÁRIO FAR.ME)':
				default:
					campaign = 'farmezeiros';
			}

			const data = {
				form: this.form,
				campanha: campaign
			};

			this.$emit('formulario', data);

			this.$refs.form.reset();
		},

		deleteIdentifier(item) {
			this.items.splice(
				this.items.indexOf(item),
				1
			);
			this.items = [...this.item];
		}
	}
};
</script>

<style scoped>
	.categoria {
		font-size: 17px;
		opacity: 0.8;
	}
</style>
